import { Collections } from 'Components/Collections';

export const CollectionsPage = () => {
	return <Collections />;
};
